<template>
  <div style="margin-top:30px">
    <el-form ref="form" :rules="rules" :model="form" label-width="100px">
      <el-form-item
        label="承运主体"
        prop="branchCode"
        style="margin-right:15px"
      >
        <el-select v-model="form.branchCode" placeholder="请选择承运主体">
          <el-option
            v-for="item in partyGroupOptions"
            :key="item.code"
            :label="item.groupName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="可编辑类型"
        prop="editType"
        style="margin-right:15px"
      >
        <el-select v-model="form.editType" placeholder="请选择" clearable>
          <el-option
            v-for="item in editTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="配置类型" prop="type" style="margin-right:15px">
        <el-input
          v-model="form.type"
          placeholder="请输入配置类型"
          maxlength="100"
        />
      </el-form-item>
      <el-form-item
        label="配置的key"
        prop="configKey"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.configKey"
          placeholder="请输入配置的key"
          maxlength="100"
        />
      </el-form-item>
      <el-form-item
        label="配置的value"
        prop="configValue"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.configValue"
          type="textarea"
          :rows="3"
          maxlength="65535"
          placeholder="请输入配置的value"
        />
      </el-form-item>
      <el-form-item
        label="配置描述"
        prop="configDesc"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.configDesc"
          placeholder="请输入配置描述"
          maxlength="800"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">取 消</el-button>
      <el-button type="primary" @click="funcSubmit">确 定</el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
export default {
  name: "PartyGroupConfigAdd",
  data() {
    return {
      form: {
        editType: "",
        type: "",
        configKey: "",
        configValue: "",
        configDesc: "",
        branchCode: ""
      },
      partyGroupOptions: [],
      // 字段类型
      editTypeOptions: [
        { label: "客户", value: "custom" },
        { label: "中台", value: "platform" }
      ],
      rules: {
        branchCode: [
          { required: true, message: "请选择承运主体", trigger: "blur" }
        ],
        editType: [
          { required: true, message: "请选择可编辑类型", trigger: "blur" }
        ],
        type: [
          { required: true, message: "请输入配置类型", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message: "长度在 1 到 100 个字符",
            trigger: "blur"
          }
        ],
        configKey: [
          { required: true, message: "请输入配置的key", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message: "长度在 1 到 100 个字符",
            trigger: "blur"
          }
        ],
        configValue: [
          { required: true, message: "请输入配置的value", trigger: "blur" },
          {
            min: 1,
            max: 65535,
            message: "长度在 1 到 65535个字符",
            trigger: "blur"
          }
        ],
        configDesc: [
          { required: true, message: "请输入配置描述", trigger: "blur" },
          {
            min: 1,
            max: 800,
            message: "长度在 1 到 800 个字符",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.getBranchList();
  },
  methods: {
    getBranchList() {
      request({
        url: "/ntocc-basic-api/partyGroup",
        method: "get"
      }).then(res => {
        if (res.status === 0) {
          console.log(this.partyGroupOptions);
          this.partyGroupOptions = res.data.records;
        }
      });
    },
    //提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const data = this.form;
          const rLoading = this.openLoading();
          request({
            url: "/ntocc-basic-api/partyGroupConfig",
            method: "post",
            params: data
          })
            .then(response => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherAddMethod");
            })
            .then(() => this.$refs["form"].resetFields());
        } else {
          return false;
        }
      });
    },
    //取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "add");
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
.el-select {
  width: 100%;
}
.el-date-editor {
  width: 100%;
}
</style>
